import { render, staticRenderFns } from "./team-sites.vue?vue&type=template&id=047da58b&scoped=true&"
import script from "./team-sites.vue?vue&type=script&lang=js&"
export * from "./team-sites.vue?vue&type=script&lang=js&"
import style0 from "./team-sites.vue?vue&type=style&index=0&id=047da58b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047da58b",
  null
  
)

component.options.__file = "team-sites.vue"
export default component.exports